import { unreachable } from '@/std/util';

export enum TabelaPrecoTipoVariacao {
    Acrescimo = 1,
    Desconto = 2,
}

export function tabelaPrecoTipoToStr(tipo: TabelaPrecoTipoVariacao) {
    switch (tipo) {
        case TabelaPrecoTipoVariacao.Acrescimo:
            return 'Acréscimo';
        case TabelaPrecoTipoVariacao.Desconto:
            return 'Desconto';
        default:
            unreachable(tipo);
    }
}

export enum TabelaPrecoExcecaoTipoPreco {
    PrecoEspecificado = 1,
    PrecoProdutoOuPacoteBarras = 2,
    PercentualAcrescimo = 3,
    PercentualDesconto = 4,
    ValorAcrescimo = 5,
    ValorDesconto = 6,
}
